import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import App from './App';
import Login from './components/auth/Login';
import PsicologoDashboard from './components/psicologo/Dashboard';
import PacienteDashboard from './components/paciente/Dashboard';
import AreaProtegida from './AreaProtegida';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/psicologo/*" element={<AreaProtegida userType="psicologo"><PsicologoDashboard /></AreaProtegida>} />
        <Route path="/paciente/*" element={<AreaProtegida userType="paciente"><PacienteDashboard /></AreaProtegida>} />
        <Route path="/*" element={<App />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
